import Vue from 'vue'
import App from './App'
import './style.css'

Vue.config.productionTip = false
new Vue({ render: h => h(App) }).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js